module.exports = __webpack_public_path__ + "img/alfie-w7.cc279b68.jpeg";